import $session from "servicestack/session";

export default {
  routes: [
    { name: "dashboard", title: "My Dashboard", hidden: true},
    { name: "orders", title: "My Orders", crm: true },
    { name: "invoices", title: "My Invoices", crm: true, hidden: true },
    {
      name: "returns",
      title: "My Credits",
      hidden: true
      // authorize: s => !s.isAdministrator()
    },
    { name: "payments", title: "Make a Payment", hidden: true },
    { name: "payment-history", title: "Payment History", hidden: true },
    {
      name: "purchase-history",
      title: "Purchase History",
      params: {
        CartStatusNotEqualTo: "Open",
        CartItemStatus: null,
        CartItemStatusNotEqualTo: "Open",
      },
    },
    {
      name: "purchase-history-open",
      title: "Open Items",
      params: {
        CartStatus: "Open",
        CartItemStatus: "Open",
      },
    },
    {
      name: "product-list",
      title: "My Product Pricing",
      hidden: true
    },
    {
      name: "placements",
      title: "Product Placements",
      hidden: true
    },
    {
      name: "profile",
      title: "My Profile",
      nav: 99,
      breadcrumbs: false,
      pageHeader: false,
      rerouteTo: "retailer.profile.shipping-locations",
      routes: [
        {
          name: "shipping-locations",
          title: "Shipping Locations",
          nav: true,
          tab: 1,
          pageHeader: false,
        },
        {
          name: "payment-methods",
          title: "Credit Cards",
          nav: true,
          tab: 2,
          pageHeader: false,
        },
        {
          name: "users",
          title: "Users",
          nav: true,
          tab: 3,
          pageHeader: false,
        },
        {
          name: "contacts",
          title: "Contacts",
          nav: false,
          tab: 4,
          pageHeader: false,
        },
        {
          name: "lists",
          title: "Lists",
          nav: true,
          tab: 5,
          pageHeader: false,
        },
      ],
    },
    { name: "blog", title: "Messages", hidden: false, nav: 12 },
    { name: "shipping-locations", title: "Shipping Locations", hidden: true },
    { name: "payment-methods", title: "Payment Methods", hidden: true },
    { name: "users", title: "Users", hidden: true },
    { name: "outlets", title: "Outlets", hidden: true },
  ],
showDashboardTerritoryManager: true,
  newLocationConfirmation: false,
  hideParcels: false,
  allowRetailerToEditSelf: false,
  hideRetailerRightAccountInfo: false,
  hideTracking: false,
  hideRetailerRep: false,
  hideAddPayment: false,
  hideDeleteCC: false,
  hideYTDBookingsHeader: true,
  quickStartCustomer: false,
  hideEditBilling: false,
  hideEditLocation: false,
  pendingRequestsTypes: [],
  maxPaidInvoices: 40,
  purchaseHistoryExportTemplate: "PurchaseHistoryExport",
  purchaseHistoryExportOrigin: "A2",
  itemHistoryExportTemplate: "ItemHistoryExportTemplate",
  itemHistoryExportOrigin: "A2",
  topSellersExportTemplate: "TopSellersExportTemplate",
  topSellersExportOrigin: "A2",
  recentItemsExportTemplate: "RecentItemsExport",
  recentItemsExportOrigin: "A2",
  registrationStatuses:
    "Request,Rep Pre-Approved,Pending,Rep Assigned,Application Complete,Rep Approved,Credit Approved,Credit Declined,Rep Declined,Not Approved",
  retailerRequestFilters: [
    { groupBy: "CustomerType" },
    {
      groupBy: "SalesRepName",
      title: "Sales Rep",
      maxHeight: 200,
      collapsed: true,
    },
  ],
	purchaseHistoryFields:
    "ProductId,Description,CartId,OrderedOn,QtyPurchased,ExtendedTotal,CartItemShipOn,ProductStatus",
  recentItemsFields:
    "Id,ProductId,Description,OrderedOn,SalesRepName,QtyPurchased,GrandTotal,CartItemShipOn,ShipName,ShipAddress,ShipCity,ShipState,ShipZip,CartItemStatus",
  itemHistoryFields: "ProductId,MfgNumber,Description,VendorName,OrderNumber,InvoiceNumber,PONumber,Qty,InvoiceLinesQty,Total,OrderDate,ShipDate,InvoiceDate,LastOrderDate", //"ProductId,MfgNumber,Description,ShipName,VendorName,SubCategoryId,OrderNumber,InvoiceNumber,PONumber,OrderDate,ShipDate,InvoiceDate,LastOrderDate,Qty,QtyShipped,InvoiceLinesQty,Total",
  itemHistoryFilters: [
    { groupBy: "OrderStatus", title: "Header Status" },
    { groupBy: "LineStatus", title: "Line Status" },
    { groupBy: "VendorName", title: "Vendor Name" },
    { date: "LastOrderDate", title: "Last Order Date" },
    {
      number: "Qty",
      title: "Total Qty",
      min: 0,
      max: 2000,
      step: 1,
    },
    {
      number: "Total",
      title: "Total $$",
      min: 0,
      max: 2000,
      step: 1,
    },
  ],
  itemInvoiceHistoryFields:
    "ProductId,MfgNumber,Description,VendorName,LastOrderDate",
  itemInvoiceHistoryFilters: [
    { date: "LastOrderDate", title: "Last Order Date" },
    {
      number: "Qty",
      title: "Total Qty",
      min: 0,
      max: 2000,
      step: 1,
    },
    {
      number: "QtyShipped",
      title: "Total Qty Shipped",
      min: 0,
      max: 2000,
      step: 1,
    },
    {
      number: "Total",
      title: "Total $$",
      min: 0,
      max: 2000,
      step: 1,
    },
  ],
  purchaseHistoryFilters: [
    { text: "CartStatus", hidden: true },
    { text: "CartStatusNotEqualTo", hidden: true },
    { text: "CartItemStatus", hidden: true },
    { text: "CartItemStatusNotEqualTo", hidden: true },
    { date: "OrderedOn", title: "Order Date" },
    { date: "CartItemShipOn", title: "Ship Date" },
    {
      number: "QtyPurchased",
      title: "Quantity",
      min: 0,
      max: 2000,
      step: 0.01,
    },
    {
      number: "ExtendedTotal",
      title: "Amount",
      min: 0,
      max: 2000,
      step: 0.01,
    },
  ],
};
